import { useState } from 'react'
import { useAuthStore } from '../../store/authStore'
import { useRateManga, useUserRating } from '../../api/useManga'
import toast from 'react-hot-toast'

export default function StarRating({ mangaId }) {
  const isAuth = useAuthStore((s) => s.isAuth)
  const [hovered, setHovered] = useState(0)
  const { mutate: rate, isPending } = useRateManga(mangaId)
  const { data: userRating } = useUserRating(mangaId)
  const currentScore = userRating?.score ?? null
  const displayScore = hovered || currentScore || 0

  const handleRate = (score) => {
    if (!isAuth) { toast.error('Войдите, чтобы оценить'); return }
    rate(score, {
      onSuccess: () => toast.success('Оценка сохранена'),
      onError: () => toast.error('Ошибка при сохранении оценки'),
    })
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1 flex-wrap">
        {Array.from({ length: 10 }).map((_, i) => {
          const score = i + 1
          const filled = score <= displayScore
          return (
            <button
              key={score}
              onClick={() => handleRate(score)}
              onMouseEnter={() => isAuth && setHovered(score)}
              onMouseLeave={() => setHovered(0)}
              disabled={isPending}
              title={isAuth ? `Оценка ${score}` : 'Войдите чтобы оценить'}
              className={`text-lg transition-all leading-none disabled:cursor-not-allowed ${filled ? 'text-accent' : 'text-line'}`}
              style={{ transform: hovered === score ? 'scale(1.2)' : 'scale(1)', cursor: isAuth ? 'pointer' : 'default' }}
            >★</button>
          )
        })}
        {currentScore && <span className="ml-1 text-sm text-accent font-bold">{currentScore}</span>}
      </div>
      {!isAuth && <span className="text-xs text-muted">Войдите, чтобы оценить</span>}
    </div>
  )
}
